<h3 class="section-title">Address</h3>
<div class="grid" [formGroup]="lotForm">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-2">
        <mat-label>Lot Number</mat-label>
        <input matInput type="number" min="0" step="1" formControlName="LotNumber" autocomplete="off" required>
        @if (hasError('LotNumber')) {
            <mat-error>{{ getErrorMessage('LotNumber', 'Lot Number') }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-2">
        <mat-label>DP Number</mat-label>
        <input matInput formControlName="DpNumber" autocomplete="off" [maxlength]="maxLengths.dpNumber">
        @if (hasError('DpNumber')) {
            <mat-error>{{ getErrorMessage('DpNumber', 'DP Number') }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-4">
        <mat-label>Street</mat-label>
        <input matInput formControlName="Street" autocomplete="address-line1" [maxlength]="maxLengths.street" required>
        @if (hasError('Street')) {
            <mat-error>{{ getErrorMessage('Street', 'Street') }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-2">
        <mat-label>Suburb</mat-label>
        <input matInput formControlName="Suburb" autocomplete="address-level2" [maxlength]="maxLengths.suburb" required>
        @if (hasError('Suburb')) {
            <mat-error>{{ getErrorMessage('Suburb', 'Suburb') }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-2">
        <mat-label>City</mat-label>
        <input matInput formControlName="City" autocomplete="address-level2" [maxlength]="maxLengths.city" required>
        @if (hasError('City')) {
            <mat-error>{{ getErrorMessage('City', 'City') }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-2">
        <mat-label>Post Code</mat-label>
        <input matInput formControlName="PostCode" inputmode="numeric" autocomplete="postal-code" [maxlength]="maxLengths.postCode">
        @if (hasError('PostCode')) {
            <mat-error>{{ getErrorMessage('PostCode', 'Post Code') }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-2">
        <mat-label>Address Region</mat-label>
        <mat-select formControlName="AddressRegion" required>
            @for (addressRegion of addressRegions; track addressRegion) {
                <mat-option [value]="addressRegion.name">
                    {{ addressRegion.name }}
                </mat-option>
            }
        </mat-select>
        @if (hasError('AddressRegion')) {
            <mat-error>{{ getErrorMessage('AddressRegion', 'Address Region') }}</mat-error>
        }
    </mat-form-field>
</div>
